<section class="title-container">
  <h2 class="title">
    {{ 'Reports.Performance.Title' | translate }}
  </h2>
  <hr class="separation-line" />
</section>

<section class="filters-container">
  <fieldset class="customers">
    <label class="label">
      {{'Reports.Filters.CustomerNumbers' | translate}}
    </label>
    <custom-multi-select [options]="customers$ | async" [searchEnabled]="userAssignedCustomersCount > 3"
      [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true" [disabled]="userAssignedCustomersCount <= 1">
    </custom-multi-select>
  </fieldset>
  <fieldset>
    <label for="period" class="label">{{'Reports.Performance.Period' | translate}}</label>
    <custom-select name="period" [options]="periodOptions" [clearEnabled]="true" [(selectedKey)]="selectedPeriod"
      (selectedKeyChange)="onChangePeriod()">
    </custom-select>
  </fieldset>
  <div class="fieldrow">
    <p-datepicker id="startDate" name="startDate" [(ngModel)]="startDate" #startDateField="ngModel"
      [dateFormat]="locale.calendar.dateFormat" [placeholder]="locale.calendar.dateFormatPlaceholder"
      [disabled]="!canEditDate">
    </p-datepicker>

    <p-datepicker id="endDate" name="endDate" [(ngModel)]="endDate" #endDateField="ngModel"
      [dateFormat]="locale.calendar.dateFormat" [placeholder]="locale.calendar.dateFormatPlaceholder"
      [disabled]="!canEditDate">
    </p-datepicker>
  </div>

  <div class="fieldrow">
    <div class="buttons">
      <button class="button-basic" (click)="onGenerateReport()">{{'Reports.Buttons.GenerateReport' |
        translate}}</button>
    </div>
  </div>
</section>

<section class="results-container" *ngIf="showResults">
  <iframe *ngIf="renderedReport" [src]="renderedReport" frameBorder="0" width="100%" height="750"></iframe>
</section>